import api from 'services/api'
import { stringifyPageQuery } from 'services/utils'

export const createUserGroup = (newGroup) =>
  api.post('/user-groups', newGroup)

export const fetchUserGroup = (groupId) =>
  api.get(`/user-groups/${groupId}`)

export const updateUserGroup = (groupId, updatedGroup) =>
  api.put(`/user-groups/${groupId}`, updatedGroup)

export const deleteUserGroup = (groupId) =>
  api.delete(`/user-groups/${groupId}`)

export const addUserGroupMember = (groupId, newMember) =>
  api.post(`/user-groups/${groupId}/members`, newMember)

export const fetchUserGroupMembers = (groupId) =>
  api.get(`/user-groups/${groupId}/members`)

export const deleteUserGroupMember = (groupId, memberId) =>
  api.delete(`/user-groups/${groupId}/members/${memberId}`)

export const fetchUserGroupsPrivileges = () =>
  api.get(`/user-groups/privileges`)

export const fetchUserGroupsPage = (params) =>
  api.get(`/user-groups?${stringifyPageQuery(params)}`)
